<span class="goal-type-display-container">
  <span class="goal-type-icon" [tooltip]="typeTooltip | translate" [triggers]="globals.tooltipTriggers" placement="bottom" container="body">
    <span class="fal fa-fw" [ngClass]="typeIconClass"></span>
  </span>
</span>